export const Role = {
  User: 'ROLE_USER',
  Admin: 'ROLE_ADMIN',
  Professional: 'ROLE_PROFESSIONAL',
  Patient: 'ROLE_PATIENT'
}
